<div class="dialogCustom--fixedHeight">
  <div mat-dialog-title>
    <div class="d-flex flex-column">
      <div class="h4 mb-0" data-testId="title">{{title}}</div>
    </div>

    <button class="align-self-start" mat-icon-button (click)="onCancel()" data-testId="close">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="noPadding">
    <nav mat-tab-nav-bar mat-stretch-tabs="false" [tabPanel]="tabPanel">
      <a
        [routerLink]="[]"
        [queryParams]="{ modal:'info', entity:context.data.id,selectedTab: DprActivityData.CustomData }"
        [replaceUrl]="true"
        (click)="activeLink = DprActivityData.CustomData"
        [active]="activeLink === DprActivityData.CustomData"
        mat-tab-link
        data-testId="select-custom-data"
      >
        <span i18n="@@dprDetails.dprEditActivityModal.btnCustomData">Custom Data</span>
      </a>
      <a
        *ngIf="!isMilestoneActivity"
        [routerLink]="[]"
        [queryParams]="{ modal:'info', entity:context.data.id,selectedTab: DprActivityData.Subactivities }"
        [replaceUrl]="true"
        (click)="activeLink = DprActivityData.Subactivities"
        [active]="activeLink === DprActivityData.Subactivities"
        mat-tab-link
        data-testId="select-sub-activities"
      >
        <span i18n="@@dprDetails.dprEditActivityModal.btnSubactivities">Sub Activities</span>
      </a>
      <a
        [routerLink]="[]"
        [queryParams]="{ modal:'info', entity:context.data.id,selectedTab: DprActivityData.Attachments }"
        [replaceUrl]="true"
        (click)="activeLink = DprActivityData.Attachments"
        [active]="activeLink === DprActivityData.Attachments"
        mat-tab-link
        data-testId="select-attachments"
      >
        <span i18n="@@dprDetails.dprEditActivityModal.btnAttachments">Attachments</span>
      </a>
    </nav>

    <mat-tab-nav-panel #tabPanel>
      <div [hidden]="activeLink !== DprActivityData.CustomData">
        <app-dpr-edit-activity-custom-data-grid
          #customDataGrid
          [canEdit]="context.allowEditing"
          [dprLockedDate]="data.context.additionalData.dprLockedDate"
          [gridData]="dprActivityCustomDataGridData"
          [activityMobilisation]="activityMobilisation"
          [activityId]="context.data.activityId"
          [customDataList]="customDataList"
          [customDataListValues]="customDataListValues"
          (gridRegistered)="onCustomDataGridRegistered($event)"
        ></app-dpr-edit-activity-custom-data-grid>
      </div>
      <div [hidden]="activeLink !== DprActivityData.Subactivities || isMilestoneActivity">
        <app-dpr-edit-activity-subactivities-grid
          #subActivitiesGrid
          [canEdit]="context.allowEditing"
          [gridData]="context.data.dprSubActivities"
          (gridRegistered)="onSubActivitiesGridRegistered($event)"
        ></app-dpr-edit-activity-subactivities-grid>
      </div>
      <div [hidden]="activeLink !== DprActivityData.Attachments" class="p-3">
        <app-dpr-attachments
          #attachmentsComponent
          [gridData]="dprActivityAttachmentsGridData"
          [namingConvention]="(userDetailsQuery.selectedSubproject$ | async)?.data?.namingConvention"
          [canEdit]="context.allowEditing"
          [clientId]="userDetailsQuery.selectedClientId$ | async"
          [isAppOnline]="isAppOnline$ | async"
          [shouldDisplayPlaceholderCounter]="false"
          [enableStickyDirective]="false"
          (gridRegistered)="onAttachmentsGridRegistered($event)"
        ></app-dpr-attachments>
      </div>
    </mat-tab-nav-panel>
  </div>

  <div mat-dialog-actions class="buttonsWrapper">
    <button mat-flat-button color="primary" (click)="onDone()" cdkFocusInitial data-testId="done">
      <mat-icon svgIcon="check"></mat-icon>
      <span>{{StaticMessage.DoneButton | staticMessage}}</span>
    </button>
    <button mat-button color="primary" (click)="onCancel()" data-testId="cancel">
      {{StaticMessage.CancelButton | staticMessage}}
    </button>
  </div>
</div>
